"use client";

import { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { Add, Minus } from "@platzi/icons";
import styles from "./NumberCounter.module.sass";

interface NumberCounterProps {
  decrease?: (newVale: number) => void;
  increase?: (newVale: number) => void;
  onChange?: (newVale: number) => void;
  initialNumber: number;
  minNumber?: number;
  maxNumber?: number;
  disabled?: boolean;
  initialNumberChange?: boolean;
  minActivationMonths: number;
}

export const NumberCounter = ({
  decrease = () => {},
  increase = () => {},
  onChange = () => {},
  initialNumber,
  minNumber,
  maxNumber,
  disabled = false,
  initialNumberChange = false,
  minActivationMonths,
}: NumberCounterProps) => {
  const [number, setNumber] = useState(initialNumber);
  const [isDisable, setIsDisable] = useState(disabled);
  const minNumberValue = minNumber || 0;
  const maxNumberValue = maxNumber || 1000;
  const cx = classNames.bind(styles);

  useEffect(() => {
    onChange(number);
  }, [number]);

  useEffect(() => {
    setNumber(initialNumber);
  }, [initialNumber]);

  useEffect(() => {
    setIsDisable(disabled);
  }, [disabled]);

  const handleDecrease = () => {
    if (number > minNumberValue) {
      setNumber(number - minActivationMonths);
      decrease(number - minActivationMonths);
    }
  };

  const handleIncrease = () => {
    if (number < maxNumberValue) {
      setNumber(number + minActivationMonths);
      increase(number + minActivationMonths);
    }
  };

  const componentStyles = cx("NumberCounter", {
    "NumberCounter--disabled": isDisable,
  });

  const inputStyles = cx("NumberCounter__input", {
    "NumberCounter__input--changed": number !== initialNumber || initialNumberChange,
  });

  return (
    <div className={componentStyles}>
      <button className={styles.NumberCounter__button} type="button" onClick={handleDecrease} disabled={isDisable}>
        <Minus />
      </button>
      <input className={inputStyles} type="text" value={number} onChange={() => {}} />
      <button className={styles.NumberCounter__button} type="button" onClick={handleIncrease} disabled={isDisable}>
        <Add />
      </button>
    </div>
  );
};
